import { IonContent, IonLoading, IonModal } from '@ionic/react';
import React from 'react';

import { Logo, Padding, Spacer } from '@/components/common';
import { Benefits, Buttons, Header, Plans } from '@/components/paywall';
import { arrowBackOutline } from 'ionicons/icons';

import './Paywall.css';

interface PaywallProps {
  isOpen: boolean;
  onClose: () => void;
  loading: boolean;
}

const Paywall: React.FC<PaywallProps> = ({ isOpen, onClose, loading }) => {
  return (
    <IonModal isOpen={isOpen} className="paywall">
      <IonContent>
        <Padding>
          <Logo leftIcon={arrowBackOutline} onClickLeftIcon={onClose} />
          <Spacer top={4} />
          <Header />
          <Spacer top={28} bottom={36}>
            <Benefits />
          </Spacer>
          <Plans />
          <Spacer top={192} />
          <Buttons />
        </Padding>
      </IonContent>

      <IonLoading isOpen={loading} message="Loading..." spinner="crescent" />
    </IonModal>
  );
};

export default Paywall;
